const Americaon2024_1=[
    {
        "Contig_Num":"41",
        "Contig_Len":"838457245",
        "GC":"38.71",
        "Scaffold_Num":"8",
        "Scaffold_Len":"838457245",
        "Gap_Num":"0",
        "Gap_Len":"0"
    }
]
export default Americaon2024_1